/**
 *	Alle components in diesem Verzeichnis (rekursiv) automatisch global registrieren.
 * 	Spart dem import innerhalb der einzelnen components.
 * 
 * 	https://vuejs.org/v2/guide/components-registration.html#Automatic-Global-Registration-of-Base-Components
 * 	https://github.com/chrisvfritz/vue-enterprise-boilerplate/blob/master/src/components/_globals.js
 * 
 */

import Vue from 'vue'
import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'

const requireComponent = require.context( './', true, /[\w-]+\.vue$/ );

requireComponent.keys().forEach((fileName) => {
	const componentConfig = requireComponent(fileName)
	const baseName = fileName.split('/').pop();
	const componentName = upperFirst(camelCase(baseName.replace(/^\.\/_/, '').replace(/\.\w+$/, '')))
	Vue.component(componentName, componentConfig.default || componentConfig)
});